export default __webpack_public_path__ + "static/media/withoutwarning.f737ec4a.png";